import React, { useEffect, useState, useContext, useRef } from 'react';

// import bootstrap components
import { Form, Col } from 'react-bootstrap';

// import custom common components
import Selecter from '../../common/Selecter';
import Filter from '../../common/Filter';

// import dummies
import { STUDIES_LEVELS, SECTORS, LANGUES, FORMATIONS_DURATIONS, COUNTRIES } from '../../../helpers/dummies';
import ListSchool from './ListSchool';

export const SharedStateContext = React.createContext();

const FilterSchool = ({ onFiltered, listOfSchools, onReseted ,favourites,opened, onClosed, handleModel }) => {

    const [filteredSchools, setFilteredSchools] = useState([]);

    const lisSchools = listOfSchools;

    const [data, setData] = useState({});
    const [firstUpdate, setFirstUpdate] = useState('');
    const [filterValues, setFilterValues] = useState({
        level: '',
        sector: '',
        language: '',
        location: '',
        duration: '',
    });

    const isFilterNotEmpty = (object) => {
        const keys = Object.keys(object);
        let hasValue = false;
        for (const key of keys) {
            if (object[key] !== '' && object[key] !== undefined && object[key] !== null){
                hasValue = true;
                break;
            }
        };
        return hasValue;
    };

    const [hasFilter, setHasFilter] = useState(true);

    const onSelected = (selected, option) => {
        setData({ ...data, [option]: [selected] });
        setFilterValues({ ...data, [option]: [selected] });
        setHasFilter(Object.keys(filterValues).length > 0);
    }

    const onChanged = (e) => {
        if (e.target) {
            let { name, value } = e.target
            setData({ ...data, [name]: value })
        }
    }

    const onSubmited = (e) => {
        e.preventDefault();
        onFiltered(data)
    }

    useEffect(() => {
        // Apply filters on the schools data
        const filteredData = listOfSchools.filter((school) => {
          const { level, sector, language, location, duration } = filterValues;
      
          return (
            (level === '' || (level && school.name?.includes(level[0]?.label))) ||
            (sector === '' || (sector && school.formations.some((formation) => formation.sector?.includes(sector[0]?.label)))) ||
            (language === '' || (language && school.formations.some((formation) => formation.language?.includes(language[0]?.label)))) ||
            (location === '' || (location && school.city?.includes(location[0]?.label))) ||
            (duration === '' || (duration && school.formations.some((formation) => formation.trainingDuration?.includes(duration[0]?.label))))
          );
        });
      
        setFilteredSchools(() => {
          if (filteredData.length || isFilterNotEmpty(filteredData)) {
            return filteredData;
          }
          return lisSchools;
        });
      }, [lisSchools, data, filterValues, firstUpdate, hasFilter]);

    useEffect(() => {
        setFirstUpdate('update');
    }, [])

    return (
        <>
        {/* <Filter withShadow onSubmited={onSubmited} onReseted={onReseted}>
            <Col lg={2} md={4} sm={12}>
                <Form.Group className="mb-0">
                    <Selecter
                        id="levels"
                        name="levels"
                        placeholder="Niveau d'étude"
                        selecterClasses="filters-selects z-30"
                        selecterClassesPrefix="filters-selects-prefix"
                        selected={data.levels || []}
                        options={STUDIES_LEVELS}
                        onSelected={onSelected}
                    />
                </Form.Group>
            </Col>
            <Col lg={3} md={4} sm={12}>
                <Form.Group className="mb-0">
                    <Selecter
                        id="sectors"
                        name="sectors"
                        placeholder="Domaines d'étude"
                        selecterClasses="filters-selects z-30"
                        selecterClassesPrefix="filters-selects-prefix"
                        selected={data.sectors || []}
                        options={SECTORS}
                        onSelected={onSelected}
                    />
                </Form.Group>
            </Col>
            <Col lg={2} md={4} sm={12}>
                <Form.Group className="mb-0">
                    <Selecter
                        id="language"
                        name="language"
                        placeholder="Langues"
                        selecterClasses="filters-selects z-30"
                        selecterClassesPrefix="filters-selects-prefix"
                        selected={data.language || []}
                        options={LANGUES}
                        onSelected={onSelected}
                    />
                </Form.Group>
            </Col>
            <Col lg={2} md={4} sm={12}>
                <Form.Group className="mb-0 h-100">
                    <Selecter
                        id="location"
                        name="location"
                        placeholder="Ville"
                        selecterClasses="filters-selects z-30"
                        selecterClassesPrefix="filters-selects-prefix"
                        selected={data.location || []}
                        options={lisSchools.map((school) => school.city)}
                        onSelected={onSelected}
                    />
                </Form.Group>
            </Col>
            <Col lg={3} md={4} sm={12}>
                <Form.Group className="mb-0">
                    <Selecter
                        id="duration"
                        name="duration"
                        placeholder="Durée de la formation"
                        selecterClasses="filters-selects z-30"
                        selecterClassesPrefix="filters-selects-prefix"
                        selected={data.duration || []}
                        options={FORMATIONS_DURATIONS}
                        onSelected={onSelected}
                    />
                </Form.Group>
            </Col>
        </Filter> */}
        <ListSchool listerClasses="z-10 mt-3 flex flex-col md:grid grid-cols-2 gap-4 p-3 list-school" items={filteredSchools} favourites={favourites} opened={opened} onClosed={onClosed} handleModel={handleModel} />
        </>
    )
}

export default FilterSchool
